module.exports = __webpack_public_path__ + "img/solution17.7319c41c.png";